<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">空防客舱扰乱事件处置系统</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="isHistory=true"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png"/>回到首页</div>
      </div>
    </div>
    <div class="decision-page">
      <div class="homepage-top" v-if="eventList.length===0">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon.png"/>
              </div>
              <div class="manage-right">
                <div class="manage-h">人员风险源管理</div>
                <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
              </div>
            </div>
            <div class="manage-bottom task-b">
              <img src="@/assets/images/qq2.png"/>
              <div class="p">暂无风险处置事件</div>
            </div>
      </div>
      <!--故障列表-->
      <div class="task-box" v-else>
        <div class="task-top">
          <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon.png"/>
              </div>
              <div class="manage-right">
                <div class="manage-h">人员风险源管理</div>
                <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
              </div>
          </div>
<!--          <div class="task-go">发起新事件</div>-->
        </div>
        <div class="task-ul">
          <div class="task-li" v-for="item in eventList" :key="item.id">
            <div class="task-text">
              <div class="task-h">{{`机舱内${checkNull(item,'typeComment')}事件`}}</div>
              <div class="task-p">
                <div class="task-laber">{{checkNull(item,'planeType')}}</div>
                <div class="task-laber" style="margin-left: 10px">{{checkNull(item,'flightNo')}}</div>
                <div class="task-laber" style="margin-left: 10px">{{checkNull(item,'planeId')}}（注册号）/{{checkNull(item,'msn')}}（MSN编号）</div>
              </div>
               <div class="task-p" style="margin-top: 10px;">
                <div class="task-laber">上报时间：{{checkNull(item,'createTimeFormat')}}</div>
               </div>
            </div>
            <div class="task-bt" @click="goEventHanding(item)">立即进入</div>
          </div>
        </div>
      </div>
    </div>
    <history-list-dialog v-if="isHistory" :dialogVisible="isHistory" :client="client" @handle-close="closeHistory"></history-list-dialog>
  </div>
</template>

<script>
  import {pageKeCang} from '@/api/kecang'
  import HistoryListDialog from "@/views/Eventhandling/components/HistoryListDialog.vue";
  export default {
    name: "risksource",
    components:{HistoryListDialog},
    data() {
      return{
        query:{
          number: 1,
          limit: 10,
        },
        params:{
          done:'false',
          orderBy:JSON.stringify([{"name":"id","direction":"DESC"}])
        },
        eventList:[],
        isScroll:false,
        client:null,
        isHistory:false
      }
    },
    created() {
      this.client=this.$route.params.client
      this.pageEvent()
    },
    methods:{
      checkNull(obj, attr) {
        return attr && obj && obj[attr] ? obj[attr] : ''
      },
      async pageEvent() {
        this.isScroll = false
        const res = await pageKeCang(this.query,this.params)
        if(res.code === 'A00000' && res.data.length) {
          this.eventList = [...this.eventList, ...res.data]
          this.isScroll = true
          if(res.data.length < 10){
            this.isScroll = false
          }
        }else {
          this.isScroll = false
        }
      },
      goEventHanding(item) {
        if (['ROLE_SOC', 'ROLE_SCDR'].includes(this.client)) {
          this.$router.push(`/CabinEvent/${this.client}/${item.id}`)
        }
      },
      closeHistory(){
        this.isHistory=false
      }
    }
  }
</script>

<style lang="less" scoped>
  .task-bt{
    border-radius: 8px;
    height: 34px;
  }
  .task-li{
    align-items: center;
    text-align: left;
  }
  .task-go{
    background: #2769EC;
    border-radius: 8px;
    width: 110px;
    height: 44px;
  }
</style>



// WEBPACK FOOTER //
// src/views/risksource/risksource.vue